/**
 * The resolved API base URL — the single place the web/native switch is made.
 *
 * Deliberately separate from `services/api`: that module is mocked by 24 test
 * files, and a plain constant shouldn't have to be re-declared in every one of
 * those mocks. Anything that builds its own URL (EventSource/SSE, OAuth popups)
 * must import from here rather than re-reading process.env — otherwise it
 * points at http://localhost:5000 inside the native WebView, i.e. at the phone
 * itself, and the request never leaves the device.
 */
import { isNative } from '../utils/platform';

// Native builds MUST hit the absolute https backend: on a device 'localhost' is
// the phone itself, and http:// is blocked (Android cleartext / iOS ATS). Web
// keeps its build-time REACT_APP_API_URL (relative/same-origin in prod).
const NATIVE_API_URL = process.env.REACT_APP_NATIVE_API_URL || 'https://centerhubapp.com/api';

export const API_BASE_URL = isNative
  ? NATIVE_API_URL
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

export default API_BASE_URL;
